import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ProgramaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ProgramaPage",
            ss: ss,
            ajax: {
                "url": ss.indexPrograma(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Programa', name: 'p.Programa', title: 'Programa' },
                { data: 'Descripcion', name: 'p.Descripcion', title: 'Descripcion' },
                { data: 'Codigo', name: 'p.Codigo', title: 'Codigo' },
                { data: 'NivelAcademico', name: 'na.NivelAcademico', title: 'NivelAcademico' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            unidadAcademicas: [],
            nivelesAcademicos: [],
            programa: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {

        getUnidadAcademica() {
            this.ss.listUnidadAcademica().then(
                (result) => {
                    let response = result.data;
                    this.unidadAcademicas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },

        getNivelAcademico() {
            this.ss.listNivelAcademico().then(
                (result) => {
                    let response = result.data;
                    this.nivelesAcademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },

        newPrograma() {
            this.programa = {};
            this.$refs['frm-programa'].show();
        },
        showPrograma(id) {
            this.isLoading=true;
            this.ss.showPrograma(id).then(
                (result) => {
                    let response = result.data;
                    this.programa = response.data;
                    this.$refs['view-programa'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPrograma() {
            this.$refs['frm-programa'].show();
            this.$refs['view-programa'].hide();
        },
        cancelPrograma() {
            if (this.programa.id) {
                this.$refs['view-programa'].show();
            }
            this.$refs['frm-programa'].hide();
        },
        savePrograma() {
            this.ss.storePrograma(this.programa).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-programa'].hide();
                    this.$refs['datatable-programa'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePrograma() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyPrograma(this.programa)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-programa'].hide();
                                this.$refs['datatable-programa'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Programa').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPrograma(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }

        this.getUnidadAcademica();
        this.getNivelAcademico();
    }
};
